//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            checkStrictly: false,
            data: [],
            columns: [],
            rowSelection: {},
            formState: {
                options: '1',
                upordown: '0',
                status: '0'
            }
        }
    },
    created() {
        this.columns.push({ title: '編號', dataIndex: 'id', key: 'id', width: 200 })
        this.columns.push({ title: '類型', dataIndex: 'type', key: 'type', })
        this.columns.push({ title: '主題', dataIndex: 'name', key: 'name', })
        this.columns.push({ title: '主辦單位', dataIndex: 'organizer', key: 'organizer', })
        this.columns.push({ title: '日期', dataIndex: 'date', key: 'date', })
        this.columns.push({ title: '場館', dataIndex: 'gymnasium', key: 'gymnasium', })
        this.columns.push({ title: '報名人數', dataIndex: 'number', key: 'number', })
        this.columns.push({ title: '狀態', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, })
        this.data = [{
            id: 'EVENT000001',
            type: '課程',
            name: '張先生',
            organizer: '主辦單位',
            date: '2025-06-24',
            gymnasium: '場館1111',
            number: '30',
            status: '已結束'
        }, {
            id: 'EVENT000002',
            name: '張先生',
            type: '活動',
            organizer: '主辦單位',
            date: '2025-06-24',
            gymnasium: '場館1111',
            number: '130',
            status: '進行中'
        }, {
            id: 'EVENT000003',
            name: '張先生',
            type: '比賽',
            organizer: '主辦單位',
            date: '2025-06-24',
            gymnasium: '場館222',
            number: '80',
            status: '進行中'
        }];
    },
    methods: {
        handleCheckOffStatusClick(e) {
            if (this.formState.options == e.target.value) {
                this.formState.options = 0;
            }
        },
        handleCheckOffStatusChange(e) {
            this.formState.options = e.target.value;
        },
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        onSelect: (record, selected, selectedRows) => {
            console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(selected, selectedRows, changeRows);
        },
        handleFinish() {

        },
        handleFinishFailed() {

        },
        toDetails(id) {
            this.$router.push(`/check-off/${id}`);
        }
    }
}
